/**
 * Positional fill palette for segmentation masks: a mask is filled with
 * `MASK_COLORS[annotationIndex % MASK_COLORS.length]`.
 *
 * Single source of truth shared across every annotation-rendering surface so they
 * all pick the identical fill:
 *  - the interactive Konva viewer (`src/components/Annotations/Segmentation/index.tsx`),
 *  - the client download/canvas renderer (`src/services/annotationRenderingService.ts`),
 *  - the server-side annotated-export renderer (`functions/src/utils/annotationRenderer.ts`).
 *
 * These must NOT collide with the measurement-axis colors (`MEASUREMENT_AXIS_COLORS`
 * in `src/utils/annotationMeasurementUtils.ts`, mirrored by the axis constants in the
 * server renderer); a mask that shares a keypoint/axis color makes the keypoints
 * disappear into the mask. The invariant is asserted in
 * `src/utils/__tests__/annotationMaskColors.test.ts`.
 *
 * NOTE: this palette was de-conflicted from the axis colors and so intentionally
 * DIVERGES from the iOS annotation renderer's mask tints. If web↔iOS mask-tint
 * parity is reintroduced, mirror the change on the iOS side rather than reverting
 * this to a clashing palette.
 */
export const MASK_COLORS = ["#FFFF00", "#FF9500", "#FF00FF", "#00FFFF", "#7CFC00", "#FFFFFF"] as const;
